module.exports = __webpack_public_path__ + "img/career.d3cf4995.svg";